// MOCK DATA - Test/fallback data for development and testing
// This file contains placeholder data that matches expected API response formats
// Used when backend endpoints are unavailable or for testing purposes

// MOCK DATA - Replace with API call to /api/scores when backend is ready
export const mockScores = [
  {
    id: 1,
    homeTeam: "Alabama",
    awayTeam: "Georgia",
    homeScore: 31,
    awayScore: 24,
    status: "Final",
    date: "2024-01-15",
    time: "8:00 PM ET",
    conference: "SEC",
  },
  {
    id: 2,
    homeTeam: "Ohio State",
    awayTeam: "Michigan",
    homeScore: 28,
    awayScore: 30,
    status: "Final",
    date: "2024-01-15",
    time: "12:00 PM ET",
    conference: "Big Ten",
  },
  {
    id: 3,
    homeTeam: "Clemson",
    awayTeam: "Florida State",
    homeScore: 21,
    awayScore: 17,
    status: "Final",
    date: "2024-01-14",
    time: "3:30 PM ET",
    conference: "ACC",
  },
  {
    id: 4,
    homeTeam: "Texas",
    awayTeam: "Oklahoma",
    homeScore: 35,
    awayScore: 28,
    status: "Final",
    date: "2024-01-14",
    time: "12:00 PM ET",
    conference: "Big 12",
  },
  {
    id: 5,
    homeTeam: "Washington State",
    awayTeam: "Oregon",
    homeScore: 24,
    awayScore: 21,
    status: "Final",
    date: "2024-01-13",
    time: "7:30 PM ET",
    conference: "Pac-12",
  },
  {
    id: 6,
    homeTeam: "USC",
    awayTeam: "UCLA",
    homeScore: 0,
    awayScore: 0,
    status: "Upcoming",
    date: "2024-01-20",
    time: "8:00 PM ET",
    conference: "Pac-12",
  },
];

// MOCK DATA - Replace with API call to /api/rankings/ap-top25 when backend is ready
export const mockRankings = [
  { rank: 1, team: "Georgia", record: "13-1", points: 1540, conference: "SEC" },
  { rank: 2, team: "Alabama", record: "12-2", points: 1480, conference: "SEC" },
  {
    rank: 3,
    team: "Ohio State",
    record: "11-2",
    points: 1420,
    conference: "Big Ten",
  },
  {
    rank: 4,
    team: "Michigan",
    record: "13-1",
    points: 1380,
    conference: "Big Ten",
  },
  { rank: 5, team: "Clemson", record: "11-3", points: 1320, conference: "ACC" },
  {
    rank: 6,
    team: "Texas",
    record: "12-2",
    points: 1280,
    conference: "Big 12",
  },
  {
    rank: 7,
    team: "Florida State",
    record: "13-1",
    points: 1240,
    conference: "ACC",
  },
  {
    rank: 8,
    team: "Washington",
    record: "14-1",
    points: 1200,
    conference: "Pac-12",
  },
  {
    rank: 9,
    team: "Oregon",
    record: "12-2",
    points: 1160,
    conference: "Pac-12",
  },
  {
    rank: 10,
    team: "Penn State",
    record: "10-3",
    points: 1120,
    conference: "Big Ten",
  },
];

// MOCK DATA - Replace with API call to /api/teams when backend is ready
export const mockTeams = [
  {
    id: 1,
    name: "Washington State",
    conference: "Pac-12",
    record: "8-5",
    logo: null, // Placeholder for team logo
    stats: {
      pointsPerGame: 28.4,
      pointsAllowed: 24.8,
      totalYards: 420.5,
    },
  },
  {
    id: 2,
    name: "Georgia",
    conference: "SEC",
    record: "13-1",
    logo: null,
    stats: {
      pointsPerGame: 41.1,
      pointsAllowed: 16.4,
      totalYards: 501.2,
    },
  },
  {
    id: 3,
    name: "Alabama",
    conference: "SEC",
    record: "12-2",
    logo: null,
    stats: {
      pointsPerGame: 35.1,
      pointsAllowed: 18.2,
      totalYards: 477.8,
    },
  },
  {
    id: 4,
    name: "Ohio State",
    conference: "Big Ten",
    record: "11-2",
    logo: null,
    stats: {
      pointsPerGame: 44.2,
      pointsAllowed: 21.0,
      totalYards: 490.3,
    },
  },
  {
    id: 5,
    name: "Michigan",
    conference: "Big Ten",
    record: "13-1",
    logo: null,
    stats: {
      pointsPerGame: 36.0,
      pointsAllowed: 13.4,
      totalYards: 452.1,
    },
  },
  {
    id: 6,
    name: "Clemson",
    conference: "ACC",
    record: "11-3",
    logo: null,
    stats: {
      pointsPerGame: 33.2,
      pointsAllowed: 20.8,
      totalYards: 445.6,
    },
  },
];

// MOCK DATA - Replace with API call to /api/search when backend is ready
export const mockSearchResults = {
  teams: [
    { name: "Washington State", conference: "Pac-12", record: "8-5" },
    { name: "Washington", conference: "Pac-12", record: "14-1" },
  ],
  games: [
    { homeTeam: "Washington State", awayTeam: "Oregon", date: "2024-01-13" },
  ],
};

// MOCK DATA - Replace with API call to /api/stats when backend is ready
// Based on NCAA.com scoring offense data
export const mockStats = {
  "Scoring Offense": [
    {
      rank: 1,
      team: "Tennessee",
      games: 5,
      touchdowns: 33,
      pat: 33,
      "2pt": 0,
      "def pts": 0,
      fg: 8,
      safety: 0,
      points: 255,
      ppg: 51.0,
    },
    {
      rank: 2,
      team: "Texas Tech",
      games: 5,
      touchdowns: 30,
      pat: 27,
      "2pt": 0,
      "def pts": 0,
      fg: 12,
      safety: 0,
      points: 243,
      ppg: 48.6,
    },
    {
      rank: 3,
      team: "Southern California",
      games: 5,
      touchdowns: 31,
      pat: 30,
      "2pt": 1,
      "def pts": 0,
      fg: 8,
      safety: 0,
      points: 242,
      ppg: 48.4,
    },
    {
      rank: 4,
      team: "Indiana",
      games: 5,
      touchdowns: 32,
      pat: 32,
      "2pt": 0,
      "def pts": 0,
      fg: 5,
      safety: 0,
      points: 239,
      ppg: 47.8,
    },
    {
      rank: 5,
      team: "Florida St.",
      games: 5,
      touchdowns: 31,
      pat: 29,
      "2pt": 2,
      "def pts": 0,
      fg: 5,
      safety: 0,
      points: 238,
      ppg: 47.6,
    },
    {
      rank: 6,
      team: "Oregon",
      games: 5,
      touchdowns: 32,
      pat: 30,
      "2pt": 1,
      "def pts": 0,
      fg: 6,
      safety: 0,
      points: 237,
      ppg: 47.4,
    },
    {
      rank: 7,
      team: "Arizona St.",
      games: 5,
      touchdowns: 30,
      pat: 28,
      "2pt": 1,
      "def pts": 0,
      fg: 8,
      safety: 0,
      points: 234,
      ppg: 46.8,
    },
    {
      rank: 8,
      team: "Washington",
      games: 5,
      touchdowns: 29,
      pat: 28,
      "2pt": 0,
      "def pts": 0,
      fg: 9,
      safety: 0,
      points: 231,
      ppg: 46.2,
    },
    {
      rank: 9,
      team: "Penn St.",
      games: 5,
      touchdowns: 28,
      pat: 27,
      "2pt": 0,
      "def pts": 0,
      fg: 10,
      safety: 0,
      points: 228,
      ppg: 45.6,
    },
    {
      rank: 10,
      team: "Ohio St.",
      games: 5,
      touchdowns: 27,
      pat: 26,
      "2pt": 0,
      "def pts": 0,
      fg: 11,
      safety: 0,
      points: 225,
      ppg: 45.0,
    },
  ],
  "Total Offense": [
    { rank: 1, team: "Oregon", games: 5, plays: 350, yards: 2500, ypg: 500.0 },
    {
      rank: 2,
      team: "Washington",
      games: 5,
      plays: 340,
      yards: 2450,
      ypg: 490.0,
    },
    {
      rank: 3,
      team: "Texas Tech",
      games: 5,
      plays: 360,
      yards: 2400,
      ypg: 480.0,
    },
    {
      rank: 4,
      team: "Tennessee",
      games: 5,
      plays: 330,
      yards: 2350,
      ypg: 470.0,
    },
    {
      rank: 5,
      team: "Southern California",
      games: 5,
      plays: 345,
      yards: 2300,
      ypg: 460.0,
    },
  ],
  "Rushing Offense": [
    {
      rank: 1,
      team: "Air Force",
      games: 5,
      attempts: 250,
      yards: 1800,
      ypg: 360.0,
    },
    { rank: 2, team: "Army", games: 5, attempts: 240, yards: 1700, ypg: 340.0 },
    { rank: 3, team: "Navy", games: 5, attempts: 230, yards: 1600, ypg: 320.0 },
    {
      rank: 4,
      team: "Georgia Tech",
      games: 5,
      attempts: 220,
      yards: 1500,
      ypg: 300.0,
    },
    {
      rank: 5,
      team: "Oregon",
      games: 5,
      attempts: 200,
      yards: 1400,
      ypg: 280.0,
    },
  ],
  "Passing Offense": [
    {
      rank: 1,
      team: "Washington",
      games: 5,
      completions: 150,
      attempts: 200,
      yards: 2100,
      ypg: 420.0,
    },
    {
      rank: 2,
      team: "Southern California",
      games: 5,
      completions: 145,
      attempts: 195,
      yards: 2050,
      ypg: 410.0,
    },
    {
      rank: 3,
      team: "Texas Tech",
      games: 5,
      completions: 140,
      attempts: 190,
      yards: 2000,
      ypg: 400.0,
    },
    {
      rank: 4,
      team: "Tennessee",
      games: 5,
      completions: 135,
      attempts: 185,
      yards: 1950,
      ypg: 390.0,
    },
    {
      rank: 5,
      team: "Oregon",
      games: 5,
      completions: 130,
      attempts: 180,
      yards: 1900,
      ypg: 380.0,
    },
  ],
};
